// src/utils/helpers.js - VERSIÓN SIMPLIFICADA Y CORREGIDA

// Función principal para parsear tokens
export const parseTokenAmount = (amount, decimals = 6) => {
  if (!amount && amount !== 0) {
    console.log('🔢 Amount vacío o undefined:', amount);
    return 0;
  }

  console.log('🔢 Parseando amount:', amount, 'Tipo:', typeof amount);

  try {
    // Si ya es un número, simplemente dividir por los decimales
    if (typeof amount === 'number') {
      const result = amount / Math.pow(10, decimals);
      console.log(`🔢 Resultado numérico: ${amount} -> ${result}`);
      return result;
    }

    // Si es string, intentar convertirlo directamente
    if (typeof amount === 'string') {
      // Limpiar el string de caracteres no numéricos
      const cleanAmount = amount.replace(/[^\d.-]/g, '');
      
      if (cleanAmount && !isNaN(cleanAmount)) {
        const numericAmount = Number(cleanAmount);
        const result = numericAmount / Math.pow(10, decimals);
        console.log(`🔢 Resultado string: ${amount} -> ${cleanAmount} -> ${result}`);
        return result;
      }
      
      // Si no se pudo limpiar, intentar parsear directamente
      if (!isNaN(amount)) {
        const result = Number(amount) / Math.pow(10, decimals);
        console.log(`🔢 Resultado directo: ${amount} -> ${result}`);
        return result;
      }
    }

    // Para objetos, buscar cualquier propiedad numérica
    if (typeof amount === 'object' && amount !== null) {
      const strValue = JSON.stringify(amount);
      const numberMatch = strValue.match(/\d+/);
      if (numberMatch) {
        const result = Number(numberMatch[0]) / Math.pow(10, decimals);
        console.log(`🔢 Resultado objeto: ${strValue} -> ${result}`);
        return result;
      }
    }

    console.warn('⚠️ No se pudo parsear el amount:', amount);
    return 0;
  } catch (error) {
    console.error('❌ Error parseando amount:', error, 'Amount:', amount);
    return 0;
  }
};

// Función ESPECIAL para CSBTC - VERSIÓN SIMPLIFICADA
export const parseCSBTCAmount = (amount) => {
  console.log('🎯 Parseando específicamente CSBTC:', amount, 'Tipo:', typeof amount);

  // CSBTC tiene 6 decimales
  const decimals = 6;

  try {
    // Usar la función principal de parsing
    const result = parseTokenAmount(amount, decimals);
    console.log(`💰 CSBTC - Resultado final: ${result} CSBTC`);
    return result;
  } catch (error) {
    console.error('❌ Error parseando CSBTC:', error);
    return 0;
  }
};

// Función MEJORADA para convertir amount - VERSIÓN SIMPLIFICADA
export const parseTokenAmountImproved = (amount, decimals = 6) => {
  return parseTokenAmount(amount, decimals);
};

// Resto de las funciones se mantienen igual...
export const formatAddress = (address) => {
  return `${address.slice(0, 4)}...${address.slice(-4)}`;
};

export const getTokenInfo = (mint, popularTokens = [], userTokens = []) => {
  if (mint === '9EpY5vX7Jwc9z9v6un8HEpRuGWrMvWenVvcM1h1EXpmR') {
    return { symbol: 'CSBTC', decimals: 6, name: 'Crosschain Bitcoin' };
  }

  const allTokens = [...popularTokens, ...userTokens];
  const token = allTokens.find(t => t.mint === mint);
  return token ? { symbol: token.symbol, decimals: token.decimals, name: token.name }
               : { symbol: 'Token', decimals: 9, name: 'Unknown Token' };
};

export const getTokenSymbol = (mint, popularTokens = [], userTokens = []) => {
  const allTokens = [...popularTokens, ...userTokens];
  const token = allTokens.find(t => t.mint === mint);
  return token ? token.symbol : 'Token';
};

export const getTokenDecimals = (mint, popularTokens = [], userTokens = []) => {
  const allTokens = [...popularTokens, ...userTokens];
  const token = allTokens.find(t => t.mint === mint);
  return token ? token.decimals : 9;
};

// ... (las funciones copyToClipboard y showManualCopyModal se mantienen igual)
export const copyToClipboard = async (text, setMessage) => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      setMessage('📋 Copiado al portapapeles!');
      return;
    }

    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);
      if (successful) {
        setMessage('📋 Copiado al portapapeles!');
      } else {
        throw new Error('Falló execCommand');
      }
    } catch (execError) {
      document.body.removeChild(textArea);
      showManualCopyModal(text, setMessage);
    }

  } catch (error) {
    console.error('Error copiando al portapapeles:', error);
    showManualCopyModal(text, setMessage);
  }
};

export const showManualCopyModal = (text, setMessage) => {
  const existingModal = document.getElementById('manual-copy-modal');
  if (existingModal) {
    document.body.removeChild(existingModal);
  }

  const modal = document.createElement('div');
  modal.id = 'manual-copy-modal';
  modal.style.position = 'fixed';
  modal.style.top = '0';
  modal.style.left = '0';
  modal.style.right = '0';
  modal.style.bottom = '0';
  modal.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
  modal.style.display = 'flex';
  modal.style.justifyContent = 'center';
  modal.style.alignItems = 'center';
  modal.style.zIndex = '10000';
  modal.style.backdropFilter = 'blur(5px)';

  modal.innerHTML = `
    <div style="background: #1a1a2e; padding: 24px; border-radius: 16px; border: 1px solid rgba(255, 255, 255, 0.2); max-width: 500px; width: 90%;">
      <h3 style="margin-top: 0; color: white; text-align: center;">Copiar Texto</h3>
      <p style="color: rgba(255, 255, 255, 0.7); margin-bottom: 16px; text-align: center;">
        Selecciona y copia el texto manualmente (Ctrl+C):
      </p>
      <textarea
        id="manual-copy-textarea"
        style="width: 100%; height: 120px; background: rgba(255, 255, 255, 0.05); border: 1px solid #9945ff; border-radius: 12px; color: white; padding: 16px; font-family: monospace; resize: none; font-size: 14px;"
        readonly
      >${text}</textarea>
      <div style="display: flex; gap: 12px; margin-top: 20px;">
        <button
          id="copy-manual-btn"
          style="flex: 1; background: linear-gradient(135deg, #9945ff, #14f195); border: none; color: white; padding: 14px; border-radius: 12px; cursor: pointer; font-weight: 600; font-size: 14px;"
        >
          📋 Intentar Copiar
        </button>
        <button
          id="close-modal-btn"
          style="flex: 1; background: rgba(255, 255, 255, 0.1); border: 1px solid rgba(255, 255, 255, 0.3); color: white; padding: 14px; border-radius: 12px; cursor: pointer; font-size: 14px;"
        >
          ✕ Cerrar
        </button>
      </div>
    </div>
  `;

  document.body.appendChild(modal);

  const textarea = modal.querySelector('#manual-copy-textarea');
  const copyManualBtn = modal.querySelector('#copy-manual-btn');
  const closeBtn = modal.querySelector('#close-modal-btn');

  textarea.select();

  copyManualBtn.onclick = () => {
    textarea.select();
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        setMessage('📋 Copiado al portapapeles!');
        document.body.removeChild(modal);
      } else {
        setMessage('⚠️ Por favor copia el texto manualmente (Ctrl+C)');
      }
    } catch (error) {
      setMessage('⚠️ Por favor copia el texto manualmente (Ctrl+C)');
    }
  };

  closeBtn.onclick = () => {
    document.body.removeChild(modal);
  };

  modal.onclick = (e) => {
    if (e.target === modal) {
      document.body.removeChild(modal);
    }
  };

  document.addEventListener('keydown', function closeOnEscape(e) {
    if (e.key === 'Escape') {
      document.body.removeChild(modal);
      document.removeEventListener('keydown', closeOnEscape);
    }
  });
};
